import {
  Button,
  SingleFieldDialog,
  SingleFieldDialogImage,
  SingleFieldDialogHeader,
  SingleFieldDialogCTA,
} from "@sellar-io/components";
import { useNavigate } from "react-router";
import * as ROUTES from "../../constants/routes";

interface EmptiedZone {
  id: number;
  name: string;
}

interface EmptyZoneAfterMoveDialogProps {
  active: boolean;
  emptiedZone: EmptiedZone | null;
  onDismiss: () => void;
  onDelete: () => void;
  isDeleting: boolean;
}

export const EmptyZoneAfterMoveDialog = ({
  active,
  emptiedZone,
  onDismiss,
  onDelete,
  isDeleting,
}: EmptyZoneAfterMoveDialogProps) => {
  const navigate = useNavigate();

  if (!emptiedZone) return null;

  return (
    <SingleFieldDialog active={active} onDismiss={onDismiss} size="large">
      <SingleFieldDialogImage src="https://sellar.imgix.net/sellar-image-assets/app-assets/delivery-zone-delete-generic.png" />
      <SingleFieldDialogHeader
        title={`Delivery zone '${emptiedZone.name}' no longer has any postcodes associated with it`}
        description={
          <>
            You can delete &apos;{emptiedZone.name}&apos; now or go to edit it.
          </>
        }
        icon="DELETE"
        iconClassName="bg-amber-50 text-amber-600"
      />

      <SingleFieldDialogCTA className="items-center">
        <Button color="transparent" onClick={onDismiss} disabled={isDeleting}>
          Dismiss
        </Button>
        <Button
          color="red"
          loading={isDeleting}
          disabled={isDeleting}
          onClick={onDelete}
        >
          Delete
        </Button>
        <Button
          color="primary"
          disabled={isDeleting}
          onClick={() => {
            navigate(
              ROUTES.DELIVERY_ZONE.href({ deliveryZoneId: emptiedZone.id }),
            );
          }}
        >
          Edit delivery zone
        </Button>
      </SingleFieldDialogCTA>
    </SingleFieldDialog>
  );
};
